// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"19f91c84","6850":"117408d7"}[chunkId] + ".chunk.css";
};